export default __webpack_public_path__ + "static/media/2-6-startNewAssessment.1d875ebc.png";